import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./../../../../assets/css/general/Homelayout/HeroSection/herosection.css";
import heroVideo from "./../../../../assets/video/MyheroVideo.mp4";

/* ── Skeleton — position:fixed so it covers the real navbar too ── */
const HeroSkeleton = () => (
  <div className="hs-hero-skeleton">

    {/* Fake Navbar */}
    <div className="hs-skeleton-navbar">
      <div className="hs-skeleton hs-skeleton-logo" />
      <div className="hs-skeleton-nav-links">
        <div className="hs-skeleton hs-skeleton-nav-link" />
        <div className="hs-skeleton hs-skeleton-nav-link" />
        <div className="hs-skeleton hs-skeleton-nav-link" />
        <div className="hs-skeleton hs-skeleton-nav-link" />
      </div>
      <div className="hs-skeleton-nav-actions">
        <div className="hs-skeleton hs-skeleton-nav-icon" />
        <div className="hs-skeleton hs-skeleton-nav-icon" />
        <div className="hs-skeleton hs-skeleton-nav-btn" />
        <div className="hs-skeleton hs-skeleton-nav-btn" />
      </div>
    </div>

    {/* Hero Body */}
    <div className="hs-skeleton-body">
      <div className="hs-skeleton-content">
        <div className="hs-skeleton hs-skeleton-heading-line hs-skeleton-h1" />
        <div className="hs-skeleton hs-skeleton-heading-line hs-skeleton-h2" />
        <div className="hs-skeleton hs-skeleton-subheading" />
        <div className="hs-skeleton hs-skeleton-btn" />
      </div>
    </div>

  </div>
);

const HeroSection = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);

  const sectionRefs = {
    aiTutor:    useRef(null),
    roadmap:    useRef(null),
    mentorship: useRef(null),
    code:       useRef(null),
    footer:     useRef(null),
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const section = searchParams.get("section");
    const targetRef = sectionRefs[section];
    if (targetRef?.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [searchParams]);

  const handleStartLearning = () => navigate("/signup");

  return (
    <>
      {/* Skeleton overlay — fixed, covers real navbar while loading */}
      {isLoading && <HeroSkeleton />}

      {/* Always render the actual hero so video can preload */}
      <section className="hs-hero-section">
        <video
          className="hs-hero-video"
          src={heroVideo}
          autoPlay
          loop
          muted
          playsInline
        />

        <div className="hs-hero-overlay" />

        <Container fluid className="hs-hero-container px-0">
          <Row className="hs-hero-content mx-0">
            <Col xs={12} className="hs-hero-text">
              <h1 className="hs-hero-heading">
                Master Tech Skills Faster
                <br />
                With AI + Real Mentors
              </h1>

              <p className="hs-hero-subheading">
                An adaptive learning engine that evolves with your skills.
              </p>

              <Button
                className="hs-hero-btn"
                onClick={handleStartLearning}
                aria-label="Start your journey"
              >
                Start Your Journey
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      <section ref={sectionRefs.aiTutor} />
      <section ref={sectionRefs.roadmap} />
      <section ref={sectionRefs.mentorship} />
      <section ref={sectionRefs.code} />
      <section ref={sectionRefs.footer} />
    </>
  );
};

export default HeroSection;